import { render, staticRenderFns } from "./CharactersList.vue?vue&type=template&id=64580cca&scoped=true&"
import script from "./CharactersList.vue?vue&type=script&lang=js&"
export * from "./CharactersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64580cca",
  null
  
)

export default component.exports